import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { media } from '../theme/base/mixins';
import { StyledComponent } from '../types';
import { FontIcon } from './FontIcon';
import { Column, Row } from './Grid';
import { Paragraph } from './Paragraph';
import { Section, SectionProps } from './Section';
import { iframeResizer } from 'iframe-resizer';

export const iframeResize = () => {iframeResizer({checkOrigin: false},'#newsletter-iframe')};

export const NewsletterHeadline = styled.span`
  vertical-align: middle;
  font-size: 2.6rem;
  line-height: 1.15;

  ${media.medium`
    font-size: 3rem;
  `};
`;

export const FontIconHeadline = FontIcon.withComponent(NewsletterHeadline);

export const NewsletterSection: StyledComponent<SectionProps> = Section.extend`
  padding-top: 20px;
  padding-bottom: 20px !important;

  ${Paragraph} {
    display: inline-block;
    margin: 0;
    padding-left: 30px;
  }

  ${FontIconHeadline} {
    padding-left: 45px;
    position: relative;

    ${media.medium`
      padding-left: 55px;
    `}

    &:before {
      font-size: 4rem;
      position: absolute;
      left: 0;
      line-height: 0.7;

      ${media.medium`
        font-size: 5rem;
      `};
    }
  }

  ${Column} {
    &:first-child {
      ${Row} {
        flex-direction: column-reverse;

        ${Column} {
          flex: inherit;
          text-align: center;
          margin-bottom: 10px;

          &:last-child {
            border-bottom: 1px solid
              ${(props: ThemeProps<Theme>) => props.theme.colors.gray};
            padding-bottom: 10px;
          }

          &:first-child {
            margin-bottom: 20px;
          }
        }

        ${media.large`
          flex-direction: row;

          ${Column} {
            flex: 1 1;
            display: flex;
            align-items: center;
            text-align: left;
            margin-bottom: 0;

            &:first-child {
              margin-bottom: 0px;
            }

            &:last-child {
              border-left: 1px solid ${(props: ThemeProps<Theme>) =>
                props.theme.colors.grayMedium};
              border-bottom: 0;
              padding-bottom: 0;
            }
          }
        `};
      }
    }
  }
`;

export const NewsletterSubline = styled.span`
  font-size: 2rem;
  line-height: 1.25;

  ${media.medium`
    font-size: 2.4rem;
  `}

  ${media.large`
      padding-left: 30px;
  `};
`;
